import { Card, CardBody, CardHeader, Heading, Skeleton, Text, Box } from '@chakra-ui/react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts'

export type BarChartRow = {
  label: string
  count: number
  color?: string
}

type Props = {
  title: string
  subtitle?: string
  data: BarChartRow[]
  loading?: boolean
  height?: number
  emptyMessage?: string
  defaultColor?: string
}

export default function ReportBarChart({
  title,
  subtitle,
  data,
  loading = false,
  height = 260,
  emptyMessage = 'No data for the current filters.',
  defaultColor = '#3182CE',
}: Props) {
  return (
    <Card h="100%">
      <CardHeader pb={2}>
        <Heading size="sm">{title}</Heading>
        {subtitle ? (
          <Text fontSize="xs" color="gray.500" mt={1}>
            {subtitle}
          </Text>
        ) : null}
      </CardHeader>
      <CardBody pt={0}>
        {loading ? (
          <Skeleton height={`${height}px`} />
        ) : data.length === 0 ? (
          <Text fontSize="sm" color="gray.500" py={8} textAlign="center">
            {emptyMessage}
          </Text>
        ) : (
          <Box h={`${height}px`} w="100%">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
                <XAxis dataKey="label" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
                <Tooltip />
                <Bar dataKey="count" name="Count" radius={[4, 4, 0, 0]}>
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color ?? defaultColor} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </Box>
        )}
      </CardBody>
    </Card>
  )
}
